// eslint-disable-next-line import/prefer-default-export
export const SEARCH_RESULTS_TYPES = {
  CITY: 'city',
  THEATER: 'theater',
};
